var { objectTemplates } = require('../data/workflowData');

var SYSTEM_OBJECT_DROPDOWN_ICONS = {
  start: 'start',
  condition: 'condition',
  variables: 'variables',
  'set-variable': 'set-variable',
  'console-log': 'console-log',
  'computer-use': 'computer-use',
  'tool-agent': 'tool-agent',
  classify: 'classify',
  router: 'router',
  'browser-run': 'browser-run',
  'browser-action': 'browser-action'
};

function buildSystemObjectOptions() {
  return objectTemplates
    .filter(function(tpl) { return tpl && tpl.icon !== 'start'; })
    .map(function(tpl) {
      // The Tool Agent template is surfaced as "tool calling node" so it pairs
      // clearly with the "tool node" (callable-tool) kind in the dropdown.
      var label = tpl.icon === 'tool-agent' ? 'tool calling node' : tpl.title;
      return {
        value: 'system:' + tpl.icon,
        label: label,
        icon: SYSTEM_OBJECT_DROPDOWN_ICONS[tpl.icon] || tpl.icon,
        templateIcon: tpl.icon
      };
    });
}

// The Tool Calling (Tool Agent) system option — reused as a kind in the
// "+ add tool" picker so the user can nest another Tool Calling node as a tool.
function toolCallingOption() {
  return buildSystemObjectOptions().find(function(o) {
    return o.templateIcon === 'tool-agent';
  }) || null;
}

function getInsertNodeKindOptions(opts) {
  // When opened from a Tool Calling node's "+ add tool" anchor, only tool-shaped
  // kinds are valid: a callable 'tool' node, or another 'tool calling node' nested
  // as a tool. The rest (Condition, Variable, Router, …) can't be wired as a tool,
  // so they're not offered here. Outside tool mode the full picker is shown WITHOUT
  // the 'tool' kind (a tool node only wires correctly from the add-tool anchor).
  if (opts && opts.allowToolNode) {
    var toolCalling = toolCallingOption();
    var toolKinds = [{ value: 'tool', label: 'tool node', icon: 'tool-agent' }];
    if (toolCalling) toolKinds.push(toolCalling);
    return toolKinds;
  }
  return [{ value: 'custom', label: 'Custom Node', icon: null }]
    .concat(buildSystemObjectOptions());
}

// A 'tool' kind is a custom node built in tool mode — not a system object.
function isToolNodeKind(nodeKind) {
  return nodeKind === 'tool';
}

function findSystemObjectTemplateByIcon(iconName) {
  var match = objectTemplates.find(function(tpl) { return tpl && tpl.icon === iconName; });
  return match || null;
}

function isSystemObjectKind(nodeKind) {
  return typeof nodeKind === 'string' && nodeKind.indexOf('system:') === 0;
}

function getSystemObjectIconFromKind(nodeKind) {
  if (!isSystemObjectKind(nodeKind)) return null;
  return nodeKind.slice('system:'.length);
}

module.exports = {
  getInsertNodeKindOptions: getInsertNodeKindOptions,
  findSystemObjectTemplateByIcon: findSystemObjectTemplateByIcon,
  isSystemObjectKind: isSystemObjectKind,
  isToolNodeKind: isToolNodeKind,
  getSystemObjectIconFromKind: getSystemObjectIconFromKind
};
